export const LINE_CHART_MARGIN = { top: 20, right: 20, bottom: 40, left: 50 };
export const TOOLTIP_OFFSET = { top: -20, left: 35 };
export const Y_AXIS_LABEL_OFFSET = 24;
